import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { EqualHeightProvider, Grid, GridColumn, Spinner, Tabs, TabsItem } from 'telia-front-react';
import ReservationStore from '../../stores/ReservationStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import BranchCard from './BranchCard';
import { City } from '../common/ReservationInterfaces';

export interface CityBranchesTabsProps {
  reservationStore?: ReservationStore;
}

const CITIES_ORDER = [
  'Tallinn',
  'Tartu',
  'Pärnu',
  'Narva',
  'Viljandi',
  'Rakvere',
  'Haapsalu',
  'Jõgeva',
  'Võru',
  'Põlva',
  'Kärdla',
  'Jõhvi',
  'Valga',
  'Kuressaare',
  'Paide',
  'Rapla'
];

@observer
class CityBranchesTabs extends React.Component<CityBranchesTabsProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  componentDidMount() {
    const { reservationStore } = this.props;
    reservationStore.fetchCities();
  }

  public render() {
    const {
      reservationStore: {
        cities: { cities, status }
      }
    } = this.props;

    if (['FETCHING', 'UNINITIALIZED'].includes(status)) {
      return <Spinner />;
    }

    return cities.length ? (
      <Tabs size="small" defaultCurrentTab={'Tallinn'} border="top" aria-labelledby="citiesHeading">
        {this.sortCitiesList(cities).map((city: City) => this.renderCityTab(city))}
      </Tabs>
    ) : null;
  }

  private renderCityTab(city: City): JSX.Element {
    const translate = this.context.translate;

    return (
      <TabsItem label={translate(`reservation.city.${city.name}`)} id={city.name} key={city.name}>
        <Grid equalHeight={true}>
          <EqualHeightProvider groups={['branch-location']}>
            {city.branches.map((branch, index) => {
              return (
                <GridColumn key={index} width={['sm-12', 'md-6', 'xl-4']}>
                  <BranchCard branch={branch} />
                </GridColumn>
              );
            })}
          </EqualHeightProvider>
        </Grid>
      </TabsItem>
    );
  }

  private sortCitiesList(cities: City[]): City[] {
    return cities.slice().sort((c1: City, c2: City) => {
      if (!CITIES_ORDER.includes(c1.name)) {
        return 1;
      }
      if (!CITIES_ORDER.includes(c2.name)) {
        return -1;
      }

      return CITIES_ORDER.indexOf(c1.name) - CITIES_ORDER.indexOf(c2.name);
    });
  }
}

export default inject('reservationStore')(CityBranchesTabs);
